import Icon from '../icon';
import Row from 'react-bootstrap/Row';
import PropTypes from 'prop-types';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
const className = augmentClassName();

const ButtonIconLink = ({ text, onClick, variant, buttonClasses, textClass, iconStyle, componentTag, fundName, fundTicker }) => {
  if (componentTag === 'PDF') {
    return (
      <Row {...className(...buttonClasses)}
        // TIAA Analytics Tracking
        data-analytics-linkname={`${fundName} | ${fundTicker}:InvestmentResults:${text.replace(/ /g, '_')}`}
        data-analytics-section="component"
        data-analytics-componenttype={componentTag}
        // END TIAA Analytics Tracking
        onClick={onClick}
        tabIndex={0}>
        <Icon variant={variant} style={iconStyle} />
        <div {...className(textClass)}>{text}</div>
      </Row>
    );
  }

  return (
    <Row {...className(...buttonClasses)}
      onClick={onClick} tabIndex={0}>
      <Icon variant={variant} style={iconStyle} />
      <div {...className(textClass)}
        // TIAA Analytics Tracking
        data-analytics-linkname={`${fundName} [${fundTicker}]:InvestmentResults:${text.replace(/ /g, '_')}`}
        data-analytics-section="component"
        data-analytics-componenttype={componentTag}
        // END TIAA Analytics Tracking
      >{text}</div>
    </Row>
  );
};

ButtonIconLink.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  buttonClasses: PropTypes.arrayOf(PropTypes.string),
  textClass: PropTypes.string,
  iconStyle: PropTypes.object,
  componentTag: PropTypes.string,
  fundName: PropTypes.string,
  fundTicker: PropTypes.string
};

ButtonIconLink.defaultProps = {
  buttonClasses: []
};

export default ButtonIconLink;
